export default __webpack_public_path__ + "static/media/event2.b0ffe8b1.png";